// generated with @7nohe/openapi-react-query-codegen@1.6.2
import { ConfigurationService } from "../requests/services.gen";
import { EmailRequest } from "../requests/types.gen";

import {
  UseMutationOptions,
  UseQueryOptions,
  useMutation,
  useQuery,
} from "@tanstack/react-query";

import * as Common from "./common";

/**
 * Redirects to an initialised configurator session for a CFG_ION_LINE
 * localeId: de-DE
 * currencyId: EUR
 * sortiment: DE
 * @param data The data for the request.
 * @param data.localeId Configurator locale (de-DE)
 * @param data.currencyId
 * @param data.sortiment Sortiment identifier used in configuration
 * @param data.fhIdent Fachhaendler Ident
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationCfgIonLineNew = <
  TData =
    Common.ConfigurationServiceGetCustomApiConfigurationCfgIonLineNewDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  {
    currencyId,
    fhIdent,
    localeId,
    sortiment,
  }: {
    currencyId?: string | undefined;
    fhIdent?: string | undefined;
    localeId?: string | undefined;
    sortiment?: string | undefined;
  } = {},
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseConfigurationServiceGetCustomApiConfigurationCfgIonLineNewKeyFn(
        { currencyId, fhIdent, localeId, sortiment },
        queryKey,
      ),
    queryFn: () =>
      ConfigurationService.getCustomApiConfigurationCfgIonLineNew({
        currencyId,
        fhIdent,
        localeId,
        sortiment,
      }) as TData,
    ...options,
  });
/**
 * Generate configuration document download.
 * Example
 *
 * sessionId: 123
 * localeId: de-DE
 * @param data The data for the request.
 * @param data.sessionId Session ID
 * @param data.localeId Configurator locale (de-DE)
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdf =
  <
    TData =
      Common.ConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      localeId,
      sessionId,
    }: {
      localeId?: string | undefined;
      sessionId: string;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseConfigurationServiceGetCustomApiConfigurationDocumentBySessionIdPdfKeyFn(
          { localeId, sessionId },
          queryKey,
        ),
      queryFn: () =>
        ConfigurationService.getCustomApiConfigurationDocumentBySessionIdPdf({
          localeId,
          sessionId,
        }) as TData,
      ...options,
    });
/**
 * Get Fachhaendler information for a given configuration session.
 * Example
 * fhIdent: CHE6315UKN01
 * lang: DE
 * country: DE
 * @param data The data for the request.
 * @param data.fhIdent Fachhaendler Ident
 * @param data.lang Language Id
 * @param data.country Country Code
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdent =
  <
    TData =
      Common.ConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentDefaultResponse,
    TError = unknown,
    TQueryKey extends Array<unknown> = unknown[],
  >(
    {
      country,
      fhIdent,
      lang,
    }: {
      country?: string | undefined;
      fhIdent: string;
      lang?: string | undefined;
    },
    queryKey?: TQueryKey,
    options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
  ) =>
    useQuery<TData, TError>({
      queryKey:
        Common.UseConfigurationServiceGetCustomApiConfigurationFachhaendlerByFhIdentKeyFn(
          { country, fhIdent, lang },
          queryKey,
        ),
      queryFn: () =>
        ConfigurationService.getCustomApiConfigurationFachhaendlerByFhIdent({
          country,
          fhIdent,
          lang,
        }) as TData,
      ...options,
    });
/**
 * Get API version information from the configuration server.
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiConfigurationInfo = <
  TData =
    Common.ConfigurationServiceGetCustomApiConfigurationInfoDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseConfigurationServiceGetCustomApiConfigurationInfoKeyFn(
        queryKey,
      ),
    queryFn: () =>
      ConfigurationService.getCustomApiConfigurationInfo() as TData,
    ...options,
  });
/**
 * Hello world for testing and healh checks
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServiceGetCustomApiHelloWorld = <
  TData = Common.ConfigurationServiceGetCustomApiHelloWorldDefaultResponse,
  TError = unknown,
  TQueryKey extends Array<unknown> = unknown[],
>(
  queryKey?: TQueryKey,
  options?: Omit<UseQueryOptions<TData, TError>, "queryKey" | "queryFn">,
) =>
  useQuery<TData, TError>({
    queryKey:
      Common.UseConfigurationServiceGetCustomApiHelloWorldKeyFn(queryKey),
    queryFn: () => ConfigurationService.getCustomApiHelloWorld() as TData,
    ...options,
  });
/**
 * Sends a quote request e-mail from the customer.
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
export const useConfigurationServicePostCustomApiConfigurationMail = <
  TData =
    Common.ConfigurationServicePostCustomApiConfigurationMailMutationResult,
  TError = unknown,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<
      TData,
      TError,
      {
        requestBody?: EmailRequest | undefined;
      },
      TContext
    >,
    "mutationFn"
  >,
) =>
  useMutation<
    TData,
    TError,
    {
      requestBody?: EmailRequest | undefined;
    },
    TContext
  >({
    mutationFn: ({ requestBody }) =>
      ConfigurationService.postCustomApiConfigurationMail({
        requestBody,
      }) as unknown as Promise<TData>,
    ...options,
  });
